import { Popover } from '@mui/material'
import { useState } from 'react'
import { PRESCRIPTION_BUILDER_VIEW_TYPES } from 'src/consumer/constants'
import {
  commonStylesPrescriptionSelect,
  loadOptionsInstructions,
} from '../../PrescriptionMakingPageComponents'
import { InstructionsSelect } from '../../PrescriptionMakingPageStyles'
import HealthEntityAddPopover from '../common/HealthEntityAddPopover'
import PrescriptionTableViewInputComponent from '../common/PrescriptionTableViewInputComponent'
import { getFirstLetterCapitalizedString } from 'src/consumer/helpers/utilFunctions'
import { handleChangeHealthEntityInputType1, handleKeyDownAndSupportEdit } from '../common/helpers'

export default function EMRInstructionsInput({
  clinicId,
  clinicBrandId,
  selectedInstructions,
  setSelectedInstructions,
  prescriptionViewSettings,
  recommendedInstructionIds = [],
}) {
  const [addInstructionButtonAnchor, setShowAddInstruction] = useState(false)
  const [instructionToCreate, setInstructionToCreate] = useState(null)

  const [inputValue, setInputValue] = useState('')

  async function createInstruction(instructionToAdd) {
    setSelectedInstructions((prev) => [...(prev || []), instructionToAdd])
    //fire api to create instruction
  }

  function onCreateInstruction(inputValue, e) {
    const instructionToAdd = {
      apiParam: 'instruction',
      value: inputValue,
      label: inputValue,
      __isNew__: true,
    }
    setInstructionToCreate(instructionToAdd)

    setShowAddInstruction(e.currentTarget)
  }

  function onChangeForNewUIItems(allValuesWithSelectedValues) {
    setSelectedInstructions(
      allValuesWithSelectedValues?.map((item) => {
        const label = item?.label || item?.value
        return { ...item, label: getFirstLetterCapitalizedString(label) }
      }),
    )
  }

  switch (prescriptionViewSettings?.prescriptionBuilderViewType) {
    case PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView:
    case PRESCRIPTION_BUILDER_VIEW_TYPES.modern:
      return (
        <>
          <PrescriptionTableViewInputComponent
            value={selectedInstructions}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            getOptionsResponse={loadOptionsInstructions}
            searchPlaceholder="Instruction"
            onChange={onChangeForNewUIItems}
            onCreate={onCreateInstruction}
            stickyHeader
            prescriptionViewSettings={prescriptionViewSettings}
            debounceTimeout={200}
            title="Instructions"
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              prescriptionViewSettings,
              recommendedInstructionIds,
            }}
            useFullPageSearch={true}
          />
          <Popover
            anchorEl={addInstructionButtonAnchor}
            open={Boolean(addInstructionButtonAnchor)}
            onClose={() => {
              setShowAddInstruction(null)
            }}
          >
            <HealthEntityAddPopover
              healthEntity={instructionToCreate}
              addToHealthEntityArray={createInstruction}
              preferredLanguages={prescriptionViewSettings?.preferredPrescriptionLanguages}
              closePopover={() => setShowAddInstruction(null)}
              healthEntityName={'Instruction'}
              apiParam={'instruction'}
            />
          </Popover>
        </>
      )
    default:
      return (
        <div style={{ width: '100%' }}>
          <InstructionsSelect
            id="instructionsSelection"
            classNamePrefix="instructions_selection"
            noOptionsMessage={() => 'Type to add new a instruction'}
            maxMenuHeight={300}
            placeholder="Select or add instructions..."
            createOptionPosition="first"
            isMulti={true}
            closeMenuOnSelect={false}
            debounceTimeout={500}
            loadOptions={loadOptionsInstructions}
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              prescriptionViewSettings,
              recommendedInstructionIds,
            }}
            styles={commonStylesPrescriptionSelect}
            isClearable={true}
            isSearchable={true}
            defaultOptions={false}
            // onCreateOption={onCreateOption}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedInstructions}
            onChange={onChangeForNewUIItems}
            inputValue={inputValue}
            onInputChange={(a, b) => {
              setInputValue((prev) => {
                if (prev === a) {
                  return prev
                }
                return a || ''
              })
              handleChangeHealthEntityInputType1(a, b, setSelectedInstructions)
            }}
            onKeyDown={(e) =>
              handleKeyDownAndSupportEdit(
                e,
                inputValue,
                selectedInstructions,
                setSelectedInstructions,
                setInputValue,
              )
            }
          />
        </div>
      )
  }
}
